<div id="drawer" class="modal fade modal-dialog-scrollable" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="offcanvas-title" id="offcanvasExampleLabel">Select your Modulations</h3>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div>        
        <div class="offcanvas-body">
          <mat-grid-list cols="2" rowHeight="4:1">
            <mat-grid-tile *ngFor="let mod of modulations; let i = index">
              <p style="text-align: left;">
                <mat-slide-toggle [(ngModel)]="mod.checked" type="checkbox" id="checkbox{{i}}"
                        name="{{mod.type}}" value="{{mod.type}}" color="primary">
                        {{mod.shortcut[0]}}<i class="{{mod.shortcut[1]}}"></i>
                </mat-slide-toggle>
              </p>
            </mat-grid-tile>
          </mat-grid-list>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="checkSelection()">Close and Save</button>
            <button type="button" class="btn btn-primary" (click)="onSubmitNewExercise()" data-bs-dismiss="modal">Save and new exercise</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div #screen class="container-fluid ml-3 mr-3 mt-3 mb-3">
  <h2 #heading>Loewe – Modulation Practice</h2>
    <div #scoreContainer class="card border-light mainContent">
      <div class="card-body" style="height: max-content;">
        <h5 class="card-title">Exercise</h5>
          <div class="spinner-border text-dark" role="status" aria-hidden="true" [hidden]="scores.done!='loading'"></div>
          <span class="svg" [innerHTML]="scores.svg" [hidden]="scores.done=='loading'"></span>
        </div>
    </div>
    <div class="card border-light">
      <div class="card-body">
          <h5 class="card-title">Options</h5>
          <div class="card-text">
          <div class="btn-group-vertical" style="width: 100%;">
            <button (click)="onSubmitNewExercise()" class="btn btn-primary">New exercise
              <span [hidden]="scores.done!='loading'" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
            <button class="btn btn-success" data-bs-toggle="modal" data-bs-target="#drawer">Select Modulations</button>
          </div>
          <br>
          <br>
          <div class="btn-group-vertical" role="group" style="width: 100%;">
            <button class="btn btn-warning" [disabled]="!scores.hint" (click)="openHint(scores.hint)">Show hint</button>
            <button class="btn btn-success" [disabled]="!scores.lsg" data-bs-toggle="modal" data-bs-target="#solution">Show sample solution</button>
          </div>
        </div>
      </div>
    </div>
</div>

<div class="modal" tabindex="-1" id="solution">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Best practice solution</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
          <div class="svg" [innerHTML]="scores.lsg"></div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" data-bs-dismiss="modal">Schließen</button>
      </div>
    </div>
  </div>
</div>